import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import JHLogoIcon from '../JHLogoIcon';
import { COLORS } from '../../constants';

export default class HeaderComponent extends React.Component {
  static propTypes = {
    dispatchUserLogout: PropTypes.func,
  };

  signOut = () => {
    this.props.dispatchUserLogout();
  };

  render() {
    const token = localStorage.getItem('accessToken');
    const styles = {
      navbar: {
        backgroundColor: COLORS.GREEN,
      },
      text: {
        color: COLORS.WHITE,
      },
    };

    return (
      <div>
        <Toolbar style={styles.navbar}>
          <ToolbarGroup>
            <IconButton
              href="https://myhardies.jameshardie.com.au"
              target="_blank"
            >
              <JHLogoIcon />
            </IconButton>

            <FlatButton
              label="myHardies Administration"
              style={styles.text}
              containerElement={<Link to="/" />}
            />
          </ToolbarGroup>

          <ToolbarGroup>
            {token && (
              <div>
                <FlatButton
                  label="Sign Out"
                  style={styles.text}
                  onClick={this.signOut}
                />
              </div>
            )}
          </ToolbarGroup>
        </Toolbar>
      </div>
    );
  }
}
